import React, { useState } from "react";
import Link_Icon from './img/Link_Icon.png';
import { ReactComponent as Next } from "./img/chevronDown.svg";
import { ReactComponent as Prev } from "./img/chevronUp.svg";
import "./Certifications.css";
import data from "../../../assets/data/certifications.json"; //certs data
import { Row } from "react-bootstrap";

export const Certifications = () => {
    const [activeIndex, setActiveIndex] = useState(0);
    const handleClick = (direction) => {
        setActiveIndex((prevIndex) => {
            if (direction === "next") {
                if (prevIndex + 1 > data.slides.length - 1) {
                    return 0;
                }
                return prevIndex + 1;
            }

            if (prevIndex - 1 < 0) {
                return data.slides.length - 1;
            }

            return prevIndex - 1;
        });
    };

    return (
        <section id="certifications">
            <div className="flex-container">

                <div className="flex-items">
                    <img
                        src={data.slides[activeIndex].content.image}
                        alt={data.slides[activeIndex].content.title}
                    />
                </div>
                <div className="flex-items">
                    <h2 className="itmes-text">{data.leadingText} {activeIndex + 1} - {data.slides[activeIndex].title}</h2>
                    <div className="itmes-text">
                        {data.slides[activeIndex].content.from}
                        <br></br>
                        Credential
                        <div className="link-icon">
                            <a href={data.slides[activeIndex].content.credential} target="_blank" rel="noopener noreferrer"><img src={Link_Icon} alt="Link Icon" /></a>
                        </div>
                        &nbsp; | &nbsp; Issued {data.slides[activeIndex].content.date}:

                    </div>
                </div>
                <div className="flex-items">
                    <Row className="button-container">
                        <button
                            type="button"
                            className="carousel-button prev"
                            onClick={() => handleClick("prev")}
                        >
                            <Prev />
                        </button>

                        <button
                            type="button"
                            className="carousel-button next"
                            onClick={() => handleClick("next")}
                        >
                            <Next />
                        </button>
                    </Row>
                </div>

            </div>

        </section>
    );
};



